import { has } from 'underscore';

export const isBulkWrappedResponse = bulkResult => has(bulkResult, 'entity'); //  && has(bulkResult, 'errors');
